import { render, staticRenderFns } from "./cryotherapyResponse.vue?vue&type=template&id=bc7ccc84&scoped=true&"
import script from "./cryotherapyResponse.vue?vue&type=script&lang=js&"
export * from "./cryotherapyResponse.vue?vue&type=script&lang=js&"
import style0 from "./cryotherapyResponse.vue?vue&type=style&index=0&id=bc7ccc84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7ccc84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7ccc84')) {
      api.createRecord('bc7ccc84', component.options)
    } else {
      api.reload('bc7ccc84', component.options)
    }
    module.hot.accept("./cryotherapyResponse.vue?vue&type=template&id=bc7ccc84&scoped=true&", function () {
      api.rerender('bc7ccc84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/components/cryotherapyResponse.vue"
export default component.exports